export default __webpack_public_path__ + "static/do-icon-color-image-f741d6f612d86304092a470f1f52efa7b957d4b2b8b448f48730c2a15baf1d88.png";